<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>
        <form-wizard color="#1F4690" error-color="#1F4690" :title="null" :subtitle="null" shape="square" content-class="p-1" class=" mb-3">
            <tab-content title="Firma" :before-change="controlFirm">
                <draft-price-firm v-model="firm" :errors="errors" :routes="c_uncalculatedRoutes"></draft-price-firm>
            </tab-content>
            <tab-content title="Sözleşme Değerleri">
                <draft-price-agreement-value v-model="agreementValue"></draft-price-agreement-value>
            </tab-content>
            <tab-content title="Hesaplama" :before-change="calculateDraftPrice">
                <draft-price-route-tab v-model="c_uncalculatedRoutes" :type="firm.PriceType"></draft-price-route-tab>
            </tab-content>
            <tab-content title="Sonuç">
                <draft-price-result v-model="c_calculatedRoutes" :type="firm.PriceType"></draft-price-result>
            </tab-content>
            <template #finish>
                <button class="btn btn-primary" v-on:click="saveDraftPrice">
                    <b-spinner class="mr-1" v-if="loading" small></b-spinner>
                    Kaydet 
                </button>
            </template>
            <template #prev>
                <button class="btn btn-outline-primary">
                    <feather-icon icon="ChevronLeftIcon" class="mr-50"></feather-icon>
                    Önceki
                </button>
            </template>
            <template #next>
                <button :disabled="calculating" class="btn btn-primary d-flex align-items-center">
                    <b-spinner class="mr-1" small v-if="calculating"></b-spinner>
                    Sonraki
                    <feather-icon icon="ChevronRightIcon" class="ml-50"></feather-icon>
                </button>
            </template>
        </form-wizard>
    </div>
</template>

<script>

import { FormWizard,TabContent } from "vue-form-wizard"
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import DraftPriceFirm from '@/views/calculate-price/draft-price/components/DraftPriceFirm.vue' 
import DraftPriceRouteTab from '@/views/calculate-price/draft-price/components/DraftPriceRouteTab.vue'
import DraftPriceResult from '@/views/calculate-price/draft-price/components/DraftPriceResult.vue'
import '@core/assets/fonts/feather/iconfont.css'
import CalculatePriceApi from '@/api/calculate-price'
import { BSpinner } from 'bootstrap-vue'
import DraftPriceAgreementValue from './components/DraftPriceAgreementValue.vue'

export default {
    components:{
        FormWizard,
        TabContent,
        DraftPriceFirm,
        DraftPriceRouteTab,
        DraftPriceResult,
        BSpinner,
        DraftPriceAgreementValue
    },
    data(){
        return{
            errors:{},
            firm:{
                Firm:null,
                FirmLocation:null,
                Province:null,
                District:null,
                Fuel:null,
                PriceType:2,
            },
            agreementValue:{
                EmptyTransportPrice:500,
                PreparedDraftOfferId:null,
                AgreementDuration:12,
                Maturity:30,
                FuelPriceChangeRate:5,
                InflationChangeDuration:3,
                IsHaveFraction:false,
                FractionNumeratorOfFuelPrice :1,  
                FractionDenominator :3, 
                FractionNumeratorOfInflationPrice :2,
                RateOfFuelPrice :50,
                RateOfInflationPrice :50,
                DraftOfferExpireDateCount :3,
                IsCompletedToFullValue :false,
                UnloadingTime :1,
                UnloadingTimeType :1,
                UnloadingTimeFaulPrice :500,
                IsFuelPriceWithTax :false,
                FrozenProductTemperature :-18,
                RateOfUfe :50,
                RateOfTufe :50,
                IsTufeUfeCompletedToFullValue :false,
                TufeUfeFractionDenominator :3,
                FractionNumeratorOfTufe :2,
                FractionNumeratorOfUfe :1,
                IsTufeUfeHaveFraction :false,
                VehicleCompartment1TemperatureLowerLimit:0,
                VehicleCompartment1TemperatureUpperLimit:0,
                VehicleCompartment2TemperatureLowerLimit:0,
                VehicleCompartment2TemperatureUpperLimit:0,
                WaitReferenceTime:"16:00",
                InflationParameterType:0,
            },
            calculating:false,
            loading:false,
            uncalculatedRoutes:[],
            calculatedRoutes:[],
        }
    },
    methods:{
        controlFirm(){
            return new Promise((resolve,reject)=>{
                if(!this.firm.Firm){ this.$set(this.errors,"Firm","Firma seçimi yapmalısınız.");reject() }
                else if(!this.firm.FirmLocation){ this.$set(this.errors,"FirmLocation","Firma lokasyonu seçimi yapmalısınız.");reject() }
                else if(!this.firm.Province){this.$set(this.errors,"FuelProvince","Yakıt ili seçimi yapmalısınız.");reject() }
                else if(!this.firm.District){ this.$set(this.errors,"FuelDistrict","Yakıt ilçesi seçimi yapmalısınız.");reject() }
                else if(!this.firm.Fuel){ this.$set(this.errors,"Fuel","Yakıt seçimi yapmalısınız.");reject() }
                else resolve(true)
            })
        },
        calculateDraftPrice(){
            return new Promise((resolve,reject)=>{
                if(!this.c_uncalculatedRoutes.UncalculatedRoutes.length){ 
                    this.$alert("En az bir rota eklenmelidir.","AlertCircleIcon","danger") 
                    reject()
                }else{
                    const data = this.c_uncalculatedRoutes.UncalculatedRoutes.map(item=>{
                        return {
                            PriceType:this.firm.PriceType,
                            DummyId:item.id,
                            StartProvinceName: item.startProvince?.Name,
                            StartProvinceId: item.startProvince?.Id,
                            StartDistrictName: item.startDistrict?.Name,
                            StartDistrictId: item.startDistrict?.Id,
                            StartNeighbourhoodId: item.startNeighbourhood?.Id,
                            StartNeighbourhoodName: item.startNeighbourhood?.Name,
                            EndProvinceName: item.endProvince?.Name,
                            EndProvinceId: item.endProvince?.Id,
                            EndDistrictName: item.endDistrict?.Name,
                            EndDistrictId: item.endDistrict?.Id,
                            EndNeighbourhoodId: item.endNeighbourhood?.Id,
                            EndNeighbourhoodName: item.endNeighbourhood?.Name,
                            IdleProvinceName: item.idleProvince?.Name || null,
                            IdleProvinceId: item.idleProvince?.Id || null,
                            IdleDistrictName: item.idleDistrict?.Name || null,
                            IdleDistrictId: item.idleDistrict?.Id || null,
                            IdleNeighbourhoodId: item.idleNeighbourhood?.Id,
                            IdleNeighbourhoodName: item.idleNeighbourhood?.Name,
                            VehicleReferenceModelName: item.referenceModel?.VehicleReferenceModelManuelName,
                            VehicleReferenceModelId: item.referenceModel?.Id,
                            FuelGroupPriceId:this.firm.Fuel,
                            CustomerKm: Number(item.customerKm),
                            CalculatedKm: Number(item.calculatedDistance),
                            IdleRouteKm: Number(item.idleDistance) || null,
                            CountOfTrips: Number(item.countOfTrips),
                            CountOfDaysWorked: Number(item.countOfDaysWorked),
                        }
                    })
                    this.calculating = true
                    CalculatePriceApi.DraftPrice.Calculate(data).then(response=>{
                        this.$result(response)
                        this.calculating = false
                        if(response.data.Success){
                            this.calculatedRoutes = response.data.Data
                            resolve(true)
                        }
                    }).catch(err=>{
                        this.$result(null,err)
                        this.calculating = false
                        reject(err)
                    })
                }
            })
        },
        saveDraftPrice(){
            let data = {
                FirmId:this.firm.Firm?.Id || null,
                FuelGroupPriceId:this.firm.Fuel,
                FirmLocationId:this.firm.FirmLocation?.Id || null,
                PriceType:this.firm.PriceType,
                AgreementValue:this.agreementValue,
                Routes:this.calculatedRoutes.map(cr=>{
                    let baseRoute = this.uncalculatedRoutes.find(ucr=> ucr.id == cr.DummyId)
                    return {
                        VehicleReferenceModelId:cr.VehicleReferenceModelId,
                        StartProvinceId:cr.StartProvinceId,
                        StartDistrictId:cr.StartDistrictId,
                        StartNeighbourhoodId:cr.StartNeighbourhoodId,
                        StartLocationLat: baseRoute?.startLatLng?.lat ? String( baseRoute?.startLatLng?.lat) : null,
                        StartLocationLong:baseRoute?.startLatLng?.lng ? String(baseRoute?.startLatLng?.lng) : null,
                        EndProvinceId:cr.EndProvinceId,
                        EndDistrictId:cr.EndDistrictId,
                        EndNeighbourhoodId:cr.EndNeighbourhoodId,
                        EndLocationLat:baseRoute?.endLatLng?.lat ? String(baseRoute?.endLatLng?.lat) : null,
                        EndLocationLong:baseRoute?.endLatLng?.lng ? String(baseRoute?.endLatLng?.lng) : null,
                        IdleProvinceId:cr.IdleProvinceId,
                        IdleDistrictId:cr.IdleDistrictId,
                        IdleNeighbourhoodId:cr.IdleNeighbourhoodId,
                        IdleLocationLat:baseRoute?.idleLatLng?.lat ? String(baseRoute?.idleLatLng?.lat) :  null,
                        IdleLocationLong:baseRoute?.idleLatLng?.lng ? String(baseRoute?.idleLatLng?.lng) : null,
                        CountOfDaysWorked:cr.CountOfDaysWorked,
                        CountOfTrips:cr.CountOfTrips,
                        IsTollRoadsActive:baseRoute?.isAvoidTolls || false,
                        IsHighwaysActive:baseRoute?.isAvoidHighways || false,
                        RoutePrices: [cr.CustomerKmResult,cr.IntegrationKmResult,cr.IntegrationKmWithIdleRouteResult].map((rp,index)=>{
                            if(rp != null){
                                return {
                                    RoutePriceType:index,
                                    DistanceKm:index == 0 ? cr.CustomerKm : index == 1 ? cr.CalculatedKm : index == 2 ? cr.IdleRouteKm : 0,
                                    FixedCost:rp.FixedCost,
                                    TotalTireUnitCost:rp.TotalTireUnitCost,
                                    TotalRevenue:rp.TotalRevenue,
                                    TotalCost:rp.TotalCost,
                                    BreakevenPointTon:rp.BreakevenPointTon,
                                    BreakevenPointTonKm:rp.BreakevenPointTonKm,
                                    BreakevenPointTotalRevenue:rp.BreakevenPointTotalRevenue,
                                    BreakevenPointKm:rp.BreakevenPointKm,
                                    BreakevenPointCostTonKm:rp.BreakevenPointCostTonKm,
                                    SalesPriceWithProfitRateCostTonKm:rp.SalesPriceWithProfitRateCostTonKm,
                                    SalesPriceWithProfitRateKm:rp.SalesPriceWithProfitRateKm,
                                    SalesPriceWithProfitRateTon:rp.SalesPriceWithProfitRateTon,
                                    LastTotalRevenueWithProfitRate:rp.LastTotalRevenueWithProfitRate,
                                    TotalCostWithProfitRate:rp.TotalCostWithProfitRate,
                                    AmountOfProfit:rp.AmountOfProfit,
                                }
                            }else return null
                        }).filter(rp => rp != null)
                    }
                })
            }
            this.loading = true
            CalculatePriceApi.DraftPriceOperation.Create(data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$router.push({name:'draft-price'})
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
            
        },
        back(){
            this.$router.push({name:'draft-price'})
        },
    },
    computed:{
        c_uncalculatedRoutes(){
            return { UncalculatedRoutes:this.uncalculatedRoutes }
        },
        c_calculatedRoutes(){
            return { CalculatedRoutes:this.calculatedRoutes }
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>